import React from "react";
import { Button } from "..";
import { useOrderContext } from "../../contexts";
import { useNavigate } from "react-router-dom";

export const BackContinue = ({
  navigateTo,
  backTo,
  backName = "Back",
  nextName = "Continue",
}) => {
  const { isSelected } = useOrderContext();
  const navigate = useNavigate();
  const navigateHandler = (decision) => {
    decision === "back" ? navigate(backTo) : navigate(navigateTo);
  };

  return (
    <div>
      <div className="btn__big_screen margin-right-20">
        <Button
          name={backName}
          moduleClass="saara__btn btn__back btn__back__bg"
          disabled={false}
          onClick={() => navigateHandler("back")}
        />
      </div>
      <div>
        <Button
          name={nextName}
          moduleClass={isSelected && "btn__continue"}
          bsClass="w-100"
          disabled={isSelected ? "" : " "}
          onClick={() => navigateHandler("continue")}
        />
      </div>
    </div>
  );
};
